import { Link } from 'react-router-dom';
import { UserMenu } from './UserMenu';
import { useAuth } from '../contexts/AuthContext';

export function MobileHeader() {
  const { status } = useAuth();
  return (
    <header
      className="md:hidden sticky top-0 z-30 flex items-center justify-between px-4 h-14 border-b border-slate-200 dark:border-slate-800 bg-white/85 dark:bg-slate-900/85 backdrop-blur"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <span className="text-base font-semibold tracking-tight text-slate-900 dark:text-slate-100">
        HookSet
      </span>
      {status === 'guest' ? (
        <Link
          to="/login"
          className="rounded-lg bg-teal-600 dark:bg-teal-500 px-3 py-1.5 text-sm font-semibold text-white hover:bg-teal-700 dark:hover:bg-teal-600 transition-colors"
        >
          Sign in
        </Link>
      ) : (
        <UserMenu align="right" />
      )}
    </header>
  );
}
